import React, { useState, useRef, useEffect } from "react"
import { graphql } from "gatsby"
import Mv from "../components/mv"
import BtmNav from "../components/btm-navs"
import Cv from "../components/cv"

import Layout from "../components/layout"
import Seo from "../components/seo"
import CaseCard from "../components/CaseCard"

import mv_img from "../images/image-mv_cases.jpg"
import mv_imgx2 from "../images/image-mv_cases@2x.jpg"
import grayIcon from "../images/icon-gray_arrow_bottom.svg"
import H2Title from "../components/H2Title"

const Cases = ({ data, location }) => {
  const siteTitle =
    "【出前館出店の事例紹介】デリバリーなら出前館 | 初期費用0円!"
  const siteDescription =
    "出前館に出店して、売り上げを伸ばしている飲食店さまの事例をご紹介します。出前館に加盟いただき、弊社が提供する様々なサービスをご利用いただくことで、より多くのお客様にお店や商品を知ってもらい、注文数増加、来店促進が期待できます。是非ご覧ください。"
  const siteKeywords =
    "出前館,出前,デリバリー,配達,宅配,出店,掲載,受注,ピックアップ"

  const [selectedFilters, setSelectedFilters] = useState({
    genre: [],
    deliveryMethod: [],
    theme: [],
  })

  const [visiblePostsCount, setVisiblePostsCount] = useState(9)
  const [isAccordionOpen, setIsAccordionOpen] = useState(false)

  let posts = data.allMarkdownRemark.nodes
  const filters = [
    {
      name: "ジャンルで絞り込む",
      items: data.allMarkdownRemark.genres,
      key: "genre",
    },
    {
      name: "配達方法で絞り込む",
      items: data.allMarkdownRemark.deliveryMethods,
      key: "deliveryMethod",
    },
    {
      name: "テーマで絞り込む",
      items: data.allMarkdownRemark.themes,
      key: "theme",
    },
  ]

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const genreFilter = searchParams.get("genre")
    if (genreFilter) {
      window.scrollTo(0, 0)
      setSelectedFilters(filters => ({
        ...filters,
        genre: [genreFilter],
      }))
    }
    const deliveryMethodFilter = searchParams.get("deliveryMethod")
    if (deliveryMethodFilter) {
      window.scrollTo(0, 0)
      setSelectedFilters(filters => ({
        ...filters,
        deliveryMethod: [deliveryMethodFilter],
      }))
    }

    const themeFilter = searchParams.get("theme")
    if (themeFilter) {
      window.scrollTo(0, 0)
      setSelectedFilters(filters => ({
        ...filters,
        theme: [themeFilter],
      }))
    }
  }, [])

  const accordionContentRef = useRef(null)

  filters.forEach(filter => {
    if (selectedFilters[filter.key].length) {
      posts = posts.filter(post =>
        selectedFilters[filter.key].some(filterValue =>
          post.frontmatter[filter.key].includes(filterValue)
        )
      )
    }
  })

  posts = posts.map(post => {
    const tags = [
      post.frontmatter.genre,
      post.frontmatter.deliveryMethod,
      post.frontmatter.theme,
    ].filter(Boolean)
    return {
      ...post,
      tags,
    }
  })

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen)
  }

  const contentHeight = accordionContentRef.current
    ? accordionContentRef.current.scrollHeight
    : 0

  const allFiltersEmpty = filters => {
    return Object.values(filters).every(filterArray => filterArray.length === 0)
  }

  return (
    <>
      <Seo
        title={siteTitle}
        description={siteDescription}
        keywords={siteKeywords}
      />
      <Layout location={location} title={siteTitle}>
        <div className="cases">
          <Mv
            title="事例紹介"
            subtitle="Case Study"
            description={`出前館に出店して、ビジネスを拡大している
        飲食店のみなさまの事例をご紹介します。`}
            bg_img={mv_img}
            bg_imgx2={mv_imgx2}
            location={location}
            postTitle={siteTitle}
          />
          <div className="container">
            <div className="cases__wrapper">
              <div class="c-title">
                <p>
                  <span>Case Study</span>
                </p>
                <h2>出店事例</h2>
                <p>
                  すでに多くのオーナー様がビジネスを
                  <br className="u-pc-hidden" />
                  拡大・効率化！出前館で続々成功しています。
                </p>
              </div>
              <div className="cases__filter">
                <div className="cases__filter-wrapper">
                  <button
                    className="cases__filter-button"
                    onClick={toggleAccordion}
                  >
                    <p className="cases__filter-title">事例を絞り込む</p>
                    <img
                      className={`${isAccordionOpen ? "open" : ""}`}
                      src={grayIcon}
                      alt="矢印"
                    />
                  </button>
                  <div
                    className={`cases__filter-inner ${
                      isAccordionOpen ? "open" : ""
                    }`}
                    ref={accordionContentRef}
                    style={{
                      maxHeight: isAccordionOpen ? `${contentHeight}px` : "0px",
                    }}
                  >
                    <div className="cases__filter-content">
                      {filters.map(filter => (
                        <div className="cases__filter-items" key={filter.key}>
                          <p className="cases__filter-name">{filter.name}</p>
                          <div className="cases__filter-item">
                            {filter.items.map(item => (
                              <label
                                key={item.fieldValue}
                                className={
                                  selectedFilters[filter.key].includes(
                                    item.fieldValue
                                  )
                                    ? "selected"
                                    : ""
                                }
                              >
                                <input
                                  type="checkbox"
                                  value={item.fieldValue}
                                  checked={selectedFilters[filter.key].includes(
                                    item.fieldValue
                                  )}
                                  onChange={() => {
                                    const updatedFilters = {
                                      ...selectedFilters,
                                    }
                                    const currentFilters =
                                      updatedFilters[filter.key]
                                    if (
                                      currentFilters.includes(item.fieldValue)
                                    ) {
                                      updatedFilters[filter.key] =
                                        currentFilters.filter(
                                          value => value !== item.fieldValue
                                        )
                                    } else {
                                      updatedFilters[filter.key] = [
                                        ...currentFilters,
                                        item.fieldValue,
                                      ]
                                    }
                                    setSelectedFilters(updatedFilters)
                                  }}
                                />
                                {item.fieldValue}
                              </label>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="cases__filter-bottom_contents">
                      <div
                        className={`cases__filter-length ${
                          allFiltersEmpty(selectedFilters) ? "hidden" : ""
                        }`}
                      >
                        <p>該当事例</p>
                        <p>
                          <span>{posts.length}</span>
                        </p>
                        <p>件</p>
                      </div>
                      <button
                        className="cases__filter-clearButton"
                        onClick={() =>
                          setSelectedFilters({
                            genre: [],
                            deliveryMethod: [],
                            theme: [],
                          })
                        }
                        type="button"
                      >
                        選択クリア
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cases__content">
                {posts.slice(0, visiblePostsCount).map(post => (
                  <CaseCard
                    key={post.fields.slug}
                    post={post}
                    currentPath={location.pathname}
                  />
                ))}
              </div>
              {visiblePostsCount < posts.length && (
                <button
                  className="cases__more_button"
                  onClick={() => setVisiblePostsCount(prev => prev + 10)}
                >
                  さらに読み込む
                </button>
              )}
            </div>
          </div>
          <BtmNav location={location} />
          <Cv />
        </div>
      </Layout>
    </>
  )
}

export default Cases

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark {
      nodes {
        id
        fields {
          slug
        }
        frontmatter {
          title
          store
          thumbnail {
            childImageSharp {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          genre
          deliveryMethod
          theme
        }
      }
      genres: group(field: frontmatter___genre) {
        fieldValue
      }
      deliveryMethods: group(field: frontmatter___deliveryMethod) {
        fieldValue
      }
      themes: group(field: frontmatter___theme) {
        fieldValue
      }
    }
  }
`
